import React, { useEffect, useLayoutEffect, useMemo, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Table, TableHeader, TableBody, TableRow, TableHead, TableCell } from "../../components/ui/table";
import { Button } from "../../components/ui/button";
import { Avatar } from "../../components/ui/avatar";
import { Pencil, Trash2, Plus, Check, Eye } from "lucide-react";
import SearchAndFilter from "../../component/SearchAndFilter/SearchAndFilter";
import { filters } from "../../utils/data";
import CustForm from "../../component/Form/CustForm";
import axios from "axios";
import { getInvestors, getInvestorsMxailMerge } from "../../store/investors";
import { getInvestorsWithFirms } from "../../store/investorsWithFirms";
import { getFirms } from "../../store/firms";
import { getUsers } from "../../store/users";
import { getCompanies } from "../../store/companies";
import {
  emailIntroduction,
  getIntroductions,
  markAndEmailIntroduction,
  markIntroduction,
} from "../../store/introductions";
import { ImageToLink } from "../../utils/api";
import { DropDown } from "../../component/DropDown/DropDown";

const default_investor = {
  photo: {
    name: "",
    base64: "",
  },
  // "https://upload.wikimedia.org/wikipedia/commons/7/7c/Profile_avatar_placeholder_large.png",
  // "",
  name: "Punitesh Poojary",
  email: "ppunitesh@gmail.com",
  stage: ["Buyout", "Growth Stage", "Mid market"],
  firmId: "66d5aa0a4249eb6d50035cd8",
  designation: "asddesign",
  sector: ["Agritech"],
  // type: "Investor",
  cities: ["Dubai", "Dhahran", "San Mateo"],
  countries: ["India", "alsdn ", "Singapore"],
  linkedIn: "somelinkedin link",
  pastInvestments: ["Arohi", "American Century"],
  locationCities: ["Dubai", "Dhahran", "San Mateo"],
  locationCountries: ["India", "alsdn ", "Singapore"],
};
const initialInvestorData = {
  photo: {
    base64: "",
    name: "",
  },
  name: "",
  email: "",
  stage: [],
  firmId: "",
  designation: "",
  level: "",
  sector: [],
  type: "",
  subCategory: "",
  cities: [],
  countries: [],
  linkedIn: "",
  pastInvestments: [],
  remarks: "",
  status: "active",
};
const initialFirmData = {
  firmName: "",
  website: "",
  logo: {
    base64: "",
    name: "",
  },
  status: "active",
};
const initialuserData = {
  email: "",
  name: "",
  type: "",
  photo: {
    base64: "",
    name: "",
  },
  companyId: "",
  linkedIn: "",
  designation: "",
  managingCompany: [],
};
const initialCompaniesData = {
  name: "",
  location: "", // required
  website: "", // required
  investmentManagerId: "", // required
  companyName: "",
  blurb: "", // required
  stage: "", // required
  sector: [],
};
const initialIntroduction = {
  investorsName: "", // required
  investorsEmail: "", // required
  investorsFirm: "", // required

  companyName: "", // required
  founderName: "", // required
  founderEmail: "", // required
};
const Admin = ({ maintype }) => {
  const dispatch = useDispatch();
  const { type } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const investors = useSelector((state) => state.investors);
  const firms = useSelector((state) => state.firms);
  const users = useSelector((state) => state.users);
  const companies = useSelector((state) => state.companies);
  const introductions = useSelector((state) => state.introductions);
  const auth = useSelector((state) => state.auth);
  const filtersStore = useSelector((state) => state.filters);
  const [goToMainMerge, setgoToMainMerge] = useState(false);

  // Form dropdown options are sourced from the managed `filters` collection.
  const filterOpts = useMemo(() => {
    const bc = filtersStore?.byCategory || {};
    const toOpts = (cat) =>
      (bc[cat] || []).map((v) => ({ id: v, name: v }));
    const REQUIRED_TYPES = ["Investor", "Banker", "Debt", "Others"];
    const typeNames = [
      ...new Set([...(bc["Type"] || []), ...REQUIRED_TYPES]),
    ];
    return {
      Type: typeNames.map((v) => ({ id: v, name: v })),
      "Funding Round": toOpts("Funding Round"),
      Sector: toOpts("Sector"),
      City: toOpts("City"),
      Country: toOpts("Country"),
    };
  }, [filtersStore?.byCategory]);

  const [search, setsearch] = useState("");
  const [showing_filters, setshowing_filters] = useState([]);
  const [current_filters, setcurrent_filters] = useState({});

  const [investorsData, setInvestorsData] = useState({
    ...initialInvestorData,
  });
  const [firmData, setFirmData] = useState({
    ...initialFirmData,
  });
  const [userData, setuserData] = useState({
    ...initialuserData,
    type:
      (type.endsWith("s") ? type.slice(0, -1) : type).charAt(0).toUpperCase() +
        (type.endsWith("s") ? type.slice(0, -1) : type).slice(1) || "",
  });
  const [companyData, setcompanyData] = useState({
    ...initialCompaniesData,
  });
  const [introductionData, setintroductionData] = useState({
    ...initialIntroduction,
  });
  const [FirstDrop, setFirstDrop] = useState("Investors");

  const [modal, setmodal] = useState({
    type: "",
    is_saving: false,
  });
  const [firm_wrt_id, setfirm_wrt_id] = useState({});
  const [to_delete, setTo_delete] = useState({
    // id: "",
    // name:"",
    // logo/photo :""
  });
  // console.log(firms);

  const [table_header, settable_header] = useState([]);
  const [table_data, settable_data] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  useEffect(() => {
    setfirm_wrt_id(
      firms.data.reduce((acc, curr) => ({ ...acc, [curr._id]: curr }), {})
    );
  }, [firms]);
  useEffect(() => {
    setCurrentPage(1);
    setcurrent_filters(
      {
        firms: {},
        companies: {
          Stage: [],
        },
        users: {},
        debts: filters,
        bankers: filters,
        investors: filters,
        // :filters
      }[type] || {}
    );
    setshowing_filters([]);
    // return () => {
    //   setcurrent_filters({ ...filters });
    //   setshowing_filters([]);
    // };
  }, [type]);
  useEffect(() => {
    let headers = [
      {
        id: "photo",
        title: "",
      },
      {
        id: "name",
        title: "Name",
      },
      {
        id: "email",
        title: "Email",
      },
      {
        id: "type",
        title: "Type",
      },
      {
        id: "firm",
        title: "Firm",
      },
      {
        id: "level",
        title: "Level",
      },
      {
        id: "action",
        title: "Actions",
      },
    ];
    let data = [];
    let trimmed_type = type.toLowerCase().slice(0, -1);

    switch (trimmed_type) {
      case "firm":
        data = [
          ...(firms?.data
            .filter((firm) => {
              let f_search = search
                ? (firm.firmName || "").toLowerCase().match(search)
                : true;
              return f_search;
            })
            .map((el) => ({
              ...el,
              photo: (
                <Avatar 
                  src={el.logo} 
                  alt={el.firmName}
                  fallback={el.firmName}
                  style={{ width: '40px', height: '40px' }}
                />
              ),
              website: (
                <a href={el.website} target="_blank" rel="noreferrer" style={{ color: '#2563eb', textDecoration: 'none' }}>
                  {el.website}
                </a>
              ),
              action: (
                <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
                  <Button
                    variant="outline"
                    size="sm"
                    onClick={() => {
                      setFirmData({
                        ...el,
                        logo: {
                          base64: el.logo,
                          name: el.firmName,
                        },
                      });
                      setmodal({
                        type: "edit",
                      });
                    }}
                    style={{ display: 'flex', alignItems: 'center', gap: '6px' }}
                  >
                    <Pencil size={14} />
                    Edit
                  </Button>
                  <Button
                    variant="destructive"
                    size="sm"
                    onClick={() => {
                      setTo_delete({
                        id: el._id,
                        name: el.firmName,
                        photo: el.logo,
                        type: "Firm",
                      });
                    }}
                    style={{ display: 'flex', alignItems: 'center', gap: '6px' }}
                  >
                    <Trash2 size={14} />
                    Delete
                  </Button>
                </div>
              ),
            })) || []),
        ];
        headers = [
          {
            id: "photo",
            title: "",
          },
          {
            id: "firmName",
            title: "Name",
          },
          {
            id: "website",
            title: "Website",
          },
          {
            id: "action",
            title: "Actions",
          },
        ];
        break;
      case "user":
        data = [
          ...(users?.data
            .filter((firm) => {
              let f_search = search
                ? [firm.name || "", firm.email || ""]
                    .join(", ")
                    .toLowerCase()
                    .match(search)
                : true;
              return f_search;
            })
            .map((el) => ({
              ...el,
              type: (
                <span style={{
                  display: 'inline-block',
                  padding: '4px 10px',
                  borderRadius: '9999px',
                  fontSize: '12px',
                  fontWeight: 500,
                  backgroundColor: el.type === 'Admin' ? '#fef3c7' : el.type === 'Manager' ? '#dbeafe' : el.type === 'Founder' ? '#dcfce7' : '#f1f5f9',
                  color: el.type === 'Admin' ? '#92400e' : el.type === 'Manager' ? '#1e40af' : el.type === 'Founder' ? '#166534' : '#475569',
                }}>
                  {el.type || '-'}
                </span>
              ),
              action: (
                <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
                  <Button
                    variant="outline"
                    size="sm"
                    onClick={() => {
                      setuserData({
                        ...el,
                        photo: el?.photo
                          ? {
                              base64: el.photo,
                              name: el.name,
                            }
                          : "",
                      });
                      setmodal({
                        type: "edit",
                      });
                    }}
                    style={{ display: 'flex', alignItems: 'center', gap: '6px' }}
                  >
                    <Pencil size={14} />
                    Edit
                  </Button>
                  <Button
                    variant="destructive"
                    size="sm"
                    onClick={() => {
                      setTo_delete({
                        id: el._id,
                        name: el.name,
                        photo: "",
                        type: "User",
                      });
                    }}
                    style={{ display: 'flex', alignItems: 'center', gap: '6px' }}
                  >
                    <Trash2 size={14} />
                    Delete
                  </Button>
                </div>
              ),
            })) || []),
        ];
        headers = [
          {
            id: "name",
            title: "Name",
          },
          {
            id: "email",
            title: "Email",
          },
          {
            id: "type",
            title: "Type",
          },
          {
            id: "action",
            title: "Actions",
          },
        ];
        break;
      case "companie":
        {
          let filters = {
            Stage: [],
          };
          data = [
            ...(companies?.data
              .filter((comapny) => {
                let f_search = search
                  ? (comapny?.blurb || "").toLowerCase().match(search)
                  : true;
                let f_stage =
                  current_filters["Stage"] && current_filters["Stage"].length
                    ? current_filters["Stage"].includes(comapny.stage)
                    : true;
                const flag = f_search && f_stage;
                // if (flag) {
                filters["Stage"].push(comapny?.stage);
                // }
                return flag;
              })
              .filter((el) => {
                if (auth.type === "Manager") {
                  return auth?.managingCompany?.includes(el._id);
                } else if (auth.type === "Founder") {
                  return auth?.companyId == el._id;
                } else {
                  return true;
                }
              })
              .map((el) => ({
                ...el,
                website: (
                  <a href={el.website} target="_blank" rel="noreferrer" style={{ color: '#2563eb', textDecoration: 'none' }}>
                    {el.website}
                  </a>
                ),
                investmentManagerId:
                  users?.wrt_id?.[el.investmentManagerId]?.name || "",
                action: (
                  <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
                    <Button
                      variant="outline"
                      size="sm"
                      onClick={() => {
                        setcompanyData({
                          ...el,
                        });
                        setmodal({
                          type: "edit",
                        });
                      }}
                      style={{ display: 'flex', alignItems: 'center', gap: '6px' }}
                    >
                      <Pencil size={14} />
                      Edit
                    </Button>
                    <Button
                      variant="destructive"
                      size="sm"
                      onClick={() => {
                        setTo_delete({
                          id: el._id,
                          name: el.name,
                          photo: "",
                          type: "Company",
                        });
                      }}
                      style={{ display: 'flex', alignItems: 'center', gap: '6px' }}
                    >
                      <Trash2 size={14} />
                      Delete
                    </Button>
                  </div>
                ),
              })) || []),
          ];
          setshowing_filters([
            {
              title: "Stage",
              children: [...new Set(filters["Stage"])].sort((a, b) =>
                a.localeCompare(b)
              ),
            },
          ]);

          //
          headers = [
            {
              id: "location",
              title: "Location",
            },
            {
              id: "website",
              title: "Website",
            },
            {
              id: "investmentManagerId",
              title: "Manager",
            },
            {
              id: "blurb",
              title: "BLURB",
            },
            {
              id: "stage",
              title: "Stage",
            },
            {
              id: "action",
              title: "Action",
            },
          ];
        }
        break;
      case "introduction":
        headers = [
          {
            id: "photo",
            title: "",
          },
          {
            id: "investername",
            title: "Invester Name",
          },
          {
            id: "foundername",
            title: "Founder Name",
          },
          {
            id: "marked",
            title: "Marked",
          },
          {
            id: "emailed",
            title: "Emailed",
          },
          {
            id: "action",
            title: "Action",
          },
        ];

        data = [
          ...(introductions.data
            .filter((introduction) => {
              let f_search = search
                ? [
                    introduction?.investorId?.name || "",
                    introduction?.userId?.name || "",
                  ]
                    .join(", ")
                    .toLowerCase()
                    .match(search)
                : true;
              return f_search;
            })
            .map((el) => ({
              ...el,
              investername: el?.investorId?.name || "Unknown Investor",
              foundername: el?.userId?.name || "",
              photo: (
                <Avatar 
                  src={el?.investorId?.photo} 
                  alt={el?.investorId?.name || "Unknown"}
                  fallback={el?.investorId?.name || "?"}
                  style={{ width: '40px', height: '40px' }}
                />
              ),
              marked: el.mark ? (
                <span style={{ color: '#16a34a', display: 'flex', alignItems: 'center', gap: '4px' }}>
                  <Check size={16} />
                </span>
              ) : (
                <span style={{ color: '#9ca3af' }}>-</span>
              ),
              emailed: el.email ? (
                <span style={{ color: '#16a34a', display: 'flex', alignItems: 'center', gap: '4px' }}>
                  <Check size={16} />
                </span>
              ) : (
                <span style={{ color: '#9ca3af' }}>-</span>
              ),
              action: (
                <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
                  <Button
                    variant="outline"
                    size="sm"
                    onClick={() => {
                      setintroductionData({
                        ...el,
                        investerphoto: {
                          base64: el?.investorId?.photo || "",
                          name: el?.investorId?.name || "",
                        },
                        investerfirmphoto: {
                          base64: firms.wrt?.[el?.investorId?.firmId]?.logo || "",
                          name: firms.wrt?.[el?.investorId?.firmId]?.firmName || "",
                        },
                        investorName: el?.investorId?.name || "",
                        investorEmail: el?.investorId?.email || "",
                        investorFirm: firms.wrt?.[el?.investorId?.firmId]?.firmName || "",
                        founderName: el?.userId?.name || "",
                        founderEmail: el?.userId?.email || "",
                      });
                      setmodal({
                        type: "edit",
                      });
                    }}
                    style={{ display: 'flex', alignItems: 'center', gap: '6px' }}
                  >
                    <Eye size={14} />
                    View
                  </Button>
                  <Button
                    variant="destructive"
                    size="sm"
                    onClick={() => {
                      setTo_delete({
                        id: el._id,
                        name: el?.investorId?.name || "Unknown Investor",
                        photo: el?.investorId?.photo || "",
                        type: "Introduction",
                      });
                    }}
                    style={{ display: 'flex', alignItems: 'center', gap: '6px' }}
                  >
                    <Trash2 size={14} />
                    Delete
                  </Button>
                </div>
              ),
            })) || []),
        ];
        break;
      case "admin":
        headers = [
          {
            id: "name",
            title: "Name",
          },
          {
            id: "email",
            title: "Email",
          },
          // {
          //   id: "type",
          //   title: "Type",
          // },
          {
            id: "action",
            title: "Action",
          },
        ];
        data = [
          ...(users?.data
            .filter((firm) => {
              let f_search = search
                ? [firm.name || "", firm.email || ""]
                    .join(", ")
                    .toLowerCase()
                    .match(search)
                : true;
              return f_search;
            })
            .filter((el) => el.type == "Admin")
            .map((el) => ({
              ...el,
              action: (
                <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
                  <Button
                    variant="outline"
                    size="sm"
                    onClick={() => {
                      setuserData({
                        ...el,
                        photo: el?.photo
                          ? {
                              base64: el.photo,
                              name: el.name,
                            }
                          : "",
                      });
                      setmodal({
                        type: "edit",
                      });
                    }}
                    style={{ display: 'flex', alignItems: 'center', gap: '6px' }}
                  >
                    <Pencil size={14} />
                    Edit
                  </Button>
                  <Button
                    variant="destructive"
                    size="sm"
                    onClick={() => {
                      setTo_delete({
                        id: el._id,
                        name: el.name,
                        photo: "",
                        type: "Admin",
                      });
                    }}
                    style={{ display: 'flex', alignItems: 'center', gap: '6px' }}
                  >
                    <Trash2 size={14} />
                    Delete
                  </Button>
                </div>
              ),
            })) || []),
        ];
        break;
      case "manager":
        headers = [
          {
            id: "name",
            title: "Name",
          },
          {
            id: "email",
            title: "Email",
          },
          // {
          //   id: "type",
          //   title: "Type",
          // },
          {
            id: "action",
            title: "Action",
          },
        ];
        data = [
          ...(users?.data
            .filter((firm) => {
              let f_search = search
                ? [firm.name || "", firm.email || ""]
                    .join(", ")
                    .toLowerCase()
                    .match(search)
                : true;
              return f_search;
            })
            .filter((el) => el.type == "Manager")
            .map((el) => ({
              ...el,
              action: (
                <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
                  <Button
                    variant="outline"
                    size="sm"
                    onClick={() => {
                      setuserData({
                        ...el,
                        photo: el?.photo
                          ? {
                              base64: el.photo,
                              name: el.name,
                            }
                          : "",
                      });
                      setmodal({
                        type: "edit",
                      });
                    }}
                    style={{ display: 'flex', alignItems: 'center', gap: '6px' }}
                  >
                    <Pencil size={14} />
                    Edit
                  </Button>
                  <Button
                    variant="destructive"
                    size="sm"
                    onClick={() => {
                      setTo_delete({
                        id: el._id,
                        name: el.name,
                        photo: "",
                        type: "Manager",
                      });
                    }}
                    style={{ display: 'flex', alignItems: 'center', gap: '6px' }}
                  >
                    <Trash2 size={14} />
                    Delete
                  </Button>
                </div>
              ),
            })) || []),
        ];
        break;
      case "founder":
        headers = [
          {
            id: "name",
            title: "Name",
          },
          {
            id: "email",
            title: "Email",
          },
          // {
          //   id: "type",
          //   title: "Type",
          // },
        ];
        if (auth.type == "Admin") {
          headers.push({
            id: "action",
            title: "Action",
          });
        }
        data = [
          ...(users?.data
            .filter((firm) => {
              let f_search = search
                ? [firm.name || "", firm.email || ""]
                    .join(", ")
                    .toLowerCase()
                    .match(search)
                : true;
              return f_search;
            })
            // .filter((el) => el.type == "Founder")
            .filter((el) => {
              if (el.type != "Founder") {
                return false;
              }
              if (auth.type === "Manager") {
                return auth?.managingCompany?.includes(el.companyId);
              } else if (auth.type === "Founder") {
                return auth?.companyId == el.companyId;
              } else {
                return true;
              }
            })
            .map((el) => ({
              ...el,
              action: (
                <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
                  <Button
                    variant="outline"
                    size="sm"
                    onClick={() => {
                      setuserData({
                        ...el,
                        photo: el?.photo
                          ? {
                              base64: el.photo,
                              name: el.name,
                            }
                          : "",
                      });
                      setmodal({
                        type: "edit",
                      });
                    }}
                    style={{ display: 'flex', alignItems: 'center', gap: '6px' }}
                  >
                    <Pencil size={14} />
                    Edit
                  </Button>
                  <Button
                    variant="destructive"
                    size="sm"
                    onClick={() => {
                      setTo_delete({
                        id: el._id,
                        name: el.name,
                        photo: "",
                        type: "Founder",
                      });
                    }}
                    style={{ display: 'flex', alignItems: 'center', gap: '6px' }}
                  >
                    <Trash2 size={14} />
                    Delete
                  </Button>
                </div>
              ),
            })) || []),
        ];
        break;
      default:
        let filters = {
          "Firm": [],
          "Funding Round": [],
          Sector: [],
          City: [],
          Country: [],
          Level: [],
        };
        data = [
          ...(investors?.data
            // .filter((el) => el.type.toLowerCase() == trimmed_type.toLowerCase())
            .filter((people) => {
              let f_type = type
                ? people.type.toLowerCase() == trimmed_type
                : true;
              let investorFirmName = firms?.wrt?.[people?.firmId]?.firmName || "";
              let f_firm =
                current_filters["Firm"] && current_filters["Firm"].length
                  ? current_filters["Firm"].includes(investorFirmName)
                  : true;
              let f_fundingRound =
                current_filters["Funding Round"] &&
                current_filters["Funding Round"].length
                  ? people?.stage?.some((ele) =>
                      current_filters["Funding Round"].includes(ele.trim())
                    )
                  : true;
              let f_sector =
                current_filters["Sector"] && current_filters["Sector"].length
                  ? people?.sector?.some((ele) =>
                      current_filters["Sector"].includes(ele.trim())
                    )
                  : true;

              let f_city =
                current_filters["City"] && current_filters["City"].length
                  ? people?.locationCities?.some((ele) =>
                      current_filters["City"].includes(ele.trim())
                    )
                  : true;
              let f_country =
                current_filters["Country"] && current_filters["Country"].length
                  ? people?.locationCountries?.some((ele) =>
                      current_filters["Country"].includes(ele.trim())
                    )
                  : true;
              let f_level =
                current_filters["Level"] &&
                current_filters["Level"].length
                  ? current_filters["Level"].includes(people?.level)
                  : true;

              let f_search = search
                ? [
                    people.name || "",
                    people.locationCountries || "",
                    people.designation || "",
                    firms?.wrt?.[people?.firmId]?.firmName || "",
                  ]
                    .join(", ")
                    .toLowerCase()
                    .match(search)
                : true;
              let flag =
                f_type &&
                f_firm &&
                f_fundingRound &&
                f_sector &&
                f_city &&
                f_country &&
                f_level &&
                f_search;
              if (flag) {
                if (investorFirmName) filters["Firm"].push(investorFirmName);
                filters["Funding Round"].push(...(people?.stage || []));
                filters["Sector"].push(...(people?.sector || []));
                filters["City"].push(...(people?.locationCities || []));
                filters["Country"].push(...(people?.locationCountries || []));
                if (people?.level) filters["Level"].push(people.level);
              }
              return flag;
            })
            .map((el) => ({
              ...el,
              photo: (
                <Avatar 
                  src={el.photo} 
                  alt={el.name}
                  fallback={el.name}
                  style={{ width: '40px', height: '40px' }}
                />
              ),
              type: (
                <span style={{
                  display: 'inline-block',
                  padding: '4px 10px',
                  borderRadius: '9999px',
                  fontSize: '12px',
                  fontWeight: 500,
                  backgroundColor: el.type === 'Investor' ? '#dcfce7' : el.type === 'Banker' ? '#dbeafe' : el.type === 'Debt' ? '#fef3c7' : '#f1f5f9',
                  color: el.type === 'Investor' ? '#166534' : el.type === 'Banker' ? '#1e40af' : el.type === 'Debt' ? '#92400e' : '#475569',
                }}>
                  {el.type || '-'}
                </span>
              ),
              firm: firms?.wrt?.[el?.firmId]?.firmName || '-',
              level: el.level || '-',
              action: (
                <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
                  <Button
                    variant="outline"
                    size="sm"
                    onClick={() => {
                      setInvestorsData({
                        ...el,
                        photo: {
                          base64: el.photo,
                          name: el.name,
                        },
                        type: el.type || "",
                        designation: el.designation || "",
                        level: el.level || "",
                        stage: Array.isArray(el.stage) ? el.stage : [],
                        sector: Array.isArray(el.sector) ? el.sector : [],
                        pastInvestments: Array.isArray(el.pastInvestments) ? el.pastInvestments : [],
                        cities: Array.isArray(el.locationCities) ? el.locationCities : [],
                        countries: Array.isArray(el.locationCountries) ? el.locationCountries : [],
                      });
                      setmodal({
                        type: "edit",
                      });
                    }}
                    style={{ display: 'flex', alignItems: 'center', gap: '6px' }}
                  >
                    <Pencil size={14} />
                    Edit
                  </Button>
                  <Button
                    variant="destructive"
                    size="sm"
                    onClick={() => {
                      setTo_delete({
                        id: el._id,
                        name: el.name,
                        photo: el.photo,
                        type: el.type,
                      });
                    }}
                    style={{ display: 'flex', alignItems: 'center', gap: '6px' }}
                  >
                    <Trash2 size={14} />
                    Delete
                  </Button>
                </div>
              ),
            })) || []),
        ];
        setshowing_filters([
          {
            title: "Firm",
            children: [...new Set(filters["Firm"])].sort((a, b) =>
              a.localeCompare(b)
            ),
            count: filters["Firm"].length,
          },
          {
            title: "Funding Round",
            children: [...new Set(filters["Funding Round"])].sort((a, b) =>
              a.localeCompare(b)
            ),
            count: filters["Funding Round"].length,
          },
          {
            title: "Sector",
            children: [...new Set(filters["Sector"])].sort((a, b) =>
              a.localeCompare(b)
            ),
            count: filters["Sector"].length,
          },
          {
            title: "City",
            children: [...new Set(filters["City"])].sort((a, b) =>
              a.localeCompare(b)
            ),
            count: filters["City"].length,
          },
          {
            title: "Country",
            children: [...new Set(filters["Country"])].sort((a, b) =>
              a.localeCompare(b)
            ),
            count: filters["Country"].length,
          },
          {
            title: "Level",
            children: [...new Set(filters["Level"])].sort((a, b) =>
              a.localeCompare(b)
            ),
            count: filters["Level"].length,
          },
        ]);
    }

    settable_header(headers);
    settable_data(data);
    setInvestorsData((prev) => ({
      ...prev,
      type: {
        investors: "Investor",
        debts: "Debt",
        bankers: "Banker",
      }[type],
    }));
    return () => {
      settable_header([]);
      settable_data({});
    };
  }, [
    investors,
    firms,
    users,
    companies,
    introductions,
    type,
    search,
    current_filters,
  ]);

  const [dropdown_open, setdropdown_open] = useState("");

  useLayoutEffect(() => {
    let t_search = location.search.slice(1);
    if (t_search) {
      setInvestorsData((prev) => ({
        ...prev,
        email: t_search,
      }));
      const currentUrl = window.location.href;
      const cleanUrl = currentUrl.split("?")[0];

      if (currentUrl !== cleanUrl) {
        window.history.replaceState(null, "", cleanUrl);
      }
      // setgoToMainMerge(true);
      setmodal({
        type: "add",
      });
    }
  }, []);
  // console.log(investors.data.map((el) => el.sector));

  useEffect(() => {
    setFirstDrop(
      {
        investors: "Investors",
        bankers: "Investors",
        debts: "Investors",
        firms: "Investors",
        admins: "Users",
        managers: "Users",
        founders: "Founder",
        companies: "Founder",
        introductions: "Introductions",
      }[type]
    );
  }, [type]);

  let userForm = [
    {
      type: "text",
      label: "Name",
      Statekey: "name",
      required: true,
    },
    {
      type: "text",
      label: "Email",
      Statekey: "email",
      required: true,
    },

    {
      type: "singleselectchips",
      label: "Type",
      Statekey: "type",
      required: true,
      options: [
        {
          id: "Founder",
          name: "Founder",
        },
        {
          id: "Manager",
          name: "Manager",
        },
        {
          id: "Admin",
          name: "Admin",
        },
      ],
    },
    userData.type == "Founder"
      ? {
          type: "text",
          label: "Designation",
          Statekey: "designation",
          required: false,
        }
      : null,
    ["Manager", "Founder"].includes(userData.type)
      ? {
          required: true,
          type:
            userData.type == "Founder"
              ? "singleselectwithsearch"
              : "multiselectwithsearch",
          label: userData.type == "Founder" ? "Company" : "Company",
          Statekey:
            userData.type == "Founder" ? "companyId" : "managingCompany",
          add: {
            status: true,
            txt: "Add company",
            onadd: () => {
              navigate(`../admin/companies`);
            },
          },
          options:
            companies?.data?.map(({ _id, blurb, photo }) => ({
              id: _id,
              name: blurb,
              show: (
                <div className="display_group">
                  <div className="txt">{blurb || ""}</div>
                </div>
              ),
            })) || [],
          option_show: (id) => (
            <div className="display_group">
              <div className="txt">{companies.wrt_id?.[id]?.blurb || ""}</div>
            </div>
          ),
        }
      : null,
    userData.type == "Founder"
      ? {
          type: "text",
          label: "LinkedIn",
          Statekey: "linkedIn",
        }
      : null,
  ].filter((el) => el);

  // console.log(["Founder", "Manager"].includes(auth.type)  );

  return (
    <>
      <div className="navbar">
        <div className="navbar_main">
          {/* <div className="nav_list">
            {(auth.type === "Admin"
              ? [
                  "Investors",
                  "Bankers",
                  "Debts",
                  "Companies",
                  "Introductions",
                  "Users",
                  "Firms",
                ]
              : ["Introductions"]
            ).map((el) => (
              <div
                className="nav_items"
                active={String(
                  !!location?.pathname?.match(
                    el.replaceAll(" ", "-").toLowerCase()
                  )
                )}
                key={el}
                onClick={() => {
                  setsearch("");
                  navigate(
                    `../${auth.type.toLowerCase()}/${el
                      .replaceAll(" ", "-")
                      .toLowerCase()}`
                  );
                }}
              >
                {el}
              </div>
            ))}
          </div> */}
          <DropDown
            {...{
              list: ["Manager", "Founder"].includes(auth.type)
                ? ["Founder", "Introductions"]
                : ["Investors", "Users", "Founder", "Introductions"],
              id: "first",
              type: FirstDrop,
              dropdown_open,
              setdropdown_open,
              onclick: (el) => {
                setsearch("");
                setFirstDrop(el);
                navigate(
                  `../${auth.type.toLowerCase()}/${{
                    Investors: ["Investors", "Bankers", "Debts", "Firms"],
                    Users: ["Admins", "Managers"],
                    Founder: ["Founders", "Companies"],
                    Introductions: ["Introductions"],
                  }[el][0]
                    .replaceAll(" ", "-")
                    .toLowerCase()}`
                );
              },
            }}
          />
          {FirstDrop == "Introductions" ? (
            ""
          ) : (
            <>
              <div className="navbar_main_sub_arrow">
                <svg
                  width="11"
                  height="11"
                  x="0"
                  y="0"
                  viewBox="0 0 451.847 451.847"
                >
                  <g>
                    <path
                      d="M225.923 354.706c-8.098 0-16.195-3.092-22.369-9.263L9.27 151.157c-12.359-12.359-12.359-32.397 0-44.751 12.354-12.354 32.388-12.354 44.748 0l171.905 171.915 171.906-171.909c12.359-12.354 32.391-12.354 44.744 0 12.365 12.354 12.365 32.392 0 44.751L248.292 345.449c-6.177 6.172-14.274 9.257-22.369 9.257z"
                      fill="#000000"
                      opacity="1"
                      data-original="#000000"
                    ></path>
                  </g>
                </svg>
              </div>
              <DropDown
                {...{
                  list: {
                    Investors: ["Investors", "Bankers", "Debts", "Firms"],
                    Users: ["Admins", "Managers"],
                    Founder: ["Founders", "Companies"],
                  }[FirstDrop],
                  id: "second",
                  type: type,
                  dropdown_open,
                  setdropdown_open,
                  onclick: (el) => {
                    setsearch("");
                    navigate(
                      `../${auth.type.toLowerCase()}/${el
                        .replaceAll(" ", "-")
                        .toLowerCase()}`
                    );
                  },
                }}
              />
            </>
          )}
          <div style={{ margin: "0 0 0 auto" }}></div>
          {true && (
            <SearchAndFilter
              {...{
                search,
                setsearch,
                showing_filters,
                current_filters,
                setcurrent_filters,
                // filter_modal: false,
                filter_modal: false,
              }}
            />
          )}
          {type != "introductions" && auth.type === "Admin" ? (
            <Button
              onClick={() => {
                setuserData({
                  ...initialuserData,
                  type:
                    (type.endsWith("s") ? type.slice(0, -1) : type)
                      .charAt(0)
                      .toUpperCase() +
                      (type.endsWith("s") ? type.slice(0, -1) : type).slice(
                        1
                      ) || "",
                });
                setmodal({
                  type: "add",
                });
              }}
              style={{ display: 'flex', alignItems: 'center', gap: '8px', whiteSpace: 'nowrap' }}
            >
              <Plus size={18} />
              Add {type == "companies" ? "company" : type?.slice(0, -1)}
            </Button>
          ) : (
            ""
          )}
        </div>
      </div>
      <div className="admin_body">
        <Table>
          <TableHeader>
            <TableRow>
              {table_header.map((header, i) => (
                <TableHead key={i} style={header.id === 'photo' ? { width: '60px' } : header.id === 'action' ? { width: '180px', textAlign: 'right' } : {}}>
                  {header.title}
                </TableHead>
              ))}
            </TableRow>
          </TableHeader>
          <TableBody>
            {table_data.length === 0 ? (
              <TableRow>
                <TableCell style={{ textAlign: 'center', padding: '2rem', color: '#9ca3af' }} colSpan={table_header.length}>
                  No data available
                </TableCell>
              </TableRow>
            ) : (
              table_data.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage).map((row, rowIndex) => (
                <TableRow key={row._id || rowIndex}>
                  {table_header.map((header, colIndex) => (
                    <TableCell key={colIndex} style={header.id === 'action' ? { textAlign: 'right' } : {}}>
                      {row[header.id] || '-'}
                    </TableCell>
                  ))}
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
        {table_data.length > itemsPerPage && (
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '1rem',
            padding: '1.5rem',
            marginTop: '1rem',
            background: 'white',
            borderRadius: '12px',
            boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
            border: '1px solid #e2e8f0',
          }}>
            <Button 
              variant="outline"
              size="sm"
              onClick={() => setCurrentPage(p => Math.max(1, p - 1))}
              disabled={currentPage === 1}
            >
              Previous
            </Button>
            <span style={{ color: '#64748b', fontSize: '0.875rem' }}>
              Page {currentPage} of {Math.ceil(table_data.length / itemsPerPage)} ({table_data.length} items)
            </span>
            <Button 
              variant="outline"
              size="sm"
              onClick={() => setCurrentPage(p => Math.min(Math.ceil(table_data.length / itemsPerPage), p + 1))}
              disabled={currentPage >= Math.ceil(table_data.length / itemsPerPage)}
            >
              Next
            </Button>
          </div>
        )}
        {to_delete?.id ? (
          <div className="delete_modal">
            <div className="delete_modal_main">
              <div className="modal_txt">
                Do you want to delete this
                <span> {type.slice(0, -1)} </span>?
              </div>
              <div className="delete_details">
                {to_delete?.photo ? (
                  <div
                    className="details_photo"
                    style={{
                      backgroundImage: `url("${to_delete?.photo || ""}")`,
                    }}
                  ></div>
                ) : (
                  ""
                )}
                <div className="details_name">{to_delete.name}</div>
              </div>
              <div className="btn_group">
                <div
                  className="modal_btn delete"
                  onClick={() => {
                    const isInvestorType = !['firms', 'users', 'admins', 'managers', 'founders', 'companies', 'introductions'].includes(type);
                    
                    if (isInvestorType) {
                      axios
                        .put(
                          "/api/investors/" + to_delete.id,
                          { status: 'deleted', deletedAt: new Date().toISOString() },
                          { headers: { "Content-Type": "application/json" } }
                        )
                        .then((response) => {
                          dispatch(getInvestors());
                          dispatch(getInvestorsWithFirms());
                          return setTo_delete({});
                        })
                        .catch((error) => {});
                    } else {
                      let config = {
                        method: "delete",
                        maxBodyLength: Infinity,
                        url:
                          ({
                            firms: "/api/investment-firms/",
                            users: "/api/users/",
                            admins: "/api/users/",
                            managers: "/api/users/",
                            founders: "/api/users/",
                            companies: "/api/companies/",
                            introductions: "/api/introductions/",
                          }[type]) + to_delete.id,
                        headers: {
                          "Content-Type": "application/json",
                        },
                      };

                      axios
                        .request(config)
                        .then((response) => {
                          dispatch(
                            {
                              firms: getFirms(),
                              users: getUsers(),
                              companies: getCompanies(),
                              introductions: getIntroductions(),
                            }[type] || getInvestors()
                          );
                          if (type == "Firm") {
                            dispatch(getInvestorsMxailMerge());
                          }
                          return setTo_delete({});
                        })
                        .catch((error) => {});
                    }
                  }}
                >
                  Delete
                </div>
                <div className="modal_btn" onClick={() => setTo_delete({})}>
                  Cancel
                </div>
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
      {modal?.type ? (
        <CustForm
          {...{
            type:
              (type != "introductions" ? modal.type : "View") +
              " " +
              (type === "companies" ? "company" : type?.slice(0, -1)), //edit//view
            inputs: {
              firms: [
                {
                  type: "text",
                  label: "Firm Name",
                  Statekey: "firmName",
                  required: true,
                },
                {
                  type: "text",
                  label: "Website",
                  Statekey: "website",
                  required: true,
                },
                {
                  type: "image",
                  label: "Logo",
                  Statekey: "logo",
                  // required: true,
                },
                {
                  type: "singleselectchips",
                  label: "Status",
                  Statekey: "status",
                  options: [
                    { id: "active", name: "Active" },
                    { id: "inactive", name: "Inactive" },
                    { id: "hidden", name: "Hidden" },
                  ],
                },
              ],
              users: [
                {
                  type: "text",
                  label: "Name",
                  Statekey: "name",
                  required: true,
                },
                {
                  type: "text",
                  label: "Email",
                  Statekey: "email",
                  required: true,
                },
                {
                  type: "image",
                  label: "Photo",
                  Statekey: "photo",
                },
                {
                  required: userData.type == "Founder",
                  type: "singleselectwithsearch",
                  label: "Company",
                  Statekey: "companyId",
                  add: {
                    status: true,
                    txt: "Add company",
                    onadd: () => {
                      navigate(`../admin/companies`);
                    },
                  },
                  options:
                    companies?.data?.map(({ _id, blurb, photo }) => ({
                      id: _id,
                      name: blurb,
                      show: (
                        <div className="display_group">
                          {/* <div
                            className="photo"
                            style={{
                              backgroundImage: `url("${photo || ""}")`,
                            }}
                          ></div> */}
                          <div className="txt">{blurb || ""}</div>
                        </div>
                      ),
                    })) || [],
                  option_show: (id) => (
                    <div className="display_group">
                      {/* <div
                        className="photo"
                        style={{
                          backgroundImage: `url("${
                            users.wrt_id?.[id]?.photo || ""
                          }")`,
                        }}
                      ></div> */}
                      <div className="txt">
                        {companies.wrt_id?.[id]?.blurb || ""}
                      </div>
                    </div>
                  ),
                },
                {
                  type: "singleselectchips",
                  label: "Type",
                  Statekey: "type",
                  required: true,
                  options: [
                    {
                      id: "Founder",
                      name: "Founder",
                    },
                    {
                      id: "Manager",
                      name: "Manager",
                    },
                    {
                      id: "Admin",
                      name: "Admin",
                    },
                  ],
                },
                {
                  type: "text",
                  label: "LinkedIn",
                  Statekey: "linkedinn",
                },
              ],
              admins: userForm,
              managers: userForm,
              founders: userForm,
              companies: [
                {
                  type: "text",
                  label: "Name",
                  Statekey: "name",
                  required: true,
                },
                {
                  type: "text",
                  label: "Location",
                  Statekey: "location",
                  required: true,
                },

                {
                  type: "text",
                  label: "Website",
                  Statekey: "website",
                  required: true,
                },
                {
                  type: "text",
                  label: "BLURB",
                  Statekey: "blurb",
                  required: true,
                  // required: true,
                },
                {
                  required: true,
                  type: "singleselectwithsearch",
                  label: "Manager",
                  Statekey: "investmentManagerId",
                  add: {
                    status: true,
                    txt: "Add user",
                    onadd: () => {
                      navigate(`../admin/users`);
                    },
                  },
                  options:
                    users?.data?.map(({ _id, name, photo }) => ({
                      id: _id,
                      name: name,
                      show: (
                        <div className="display_group">
                          <div
                            className="photo"
                            style={{
                              backgroundImage: `url("${photo || ""}")`,
                            }}
                          ></div>
                          <div className="txt">{name || ""}</div>
                        </div>
                      ),
                    })) || [],
                  option_show: (id) => (
                    <div className="display_group">
                      <div
                        className="photo"
                        style={{
                          backgroundImage: `url("${
                            users.wrt_id?.[id]?.photo || ""
                          }")`,
                        }}
                      ></div>
                      <div className="txt">
                        {users.wrt_id?.[id]?.name || ""}
                      </div>
                    </div>
                  ),
                },

                {
                  type: "singleselectchips",
                  label: "Funding Stage",
                  Statekey: "stage",
                  required: true,
                  options: [
                    {
                      id: "Early",
                      name: "Early",
                    },
                    {
                      id: "Growth",
                      name: "Growth",
                    },
                    {
                      id: "Pre-IPO",
                      name: "Pre-IPO",
                    },
                  ],
                },
                {
                  required: true,
                  type: "multiselect",
                  label: "Sector",
                  Statekey: "sector",
                  options: [
                    ...new Set(
                      investors?.data
                        ?.flatMap((item) => item.sector)
                        .filter((sector) => sector !== "")
                    ),
                  ]
                    .sort((a, b) => a.localeCompare(b))
                    .map((el) => ({
                      id: el,
                      name: el,
                    })),
                },
              ],
              introductions: [
                {
                  type: "imageview",
                  label: "Invester Name and Photo",
                  Statekey: "investerphoto",
                },
                {
                  type: "imageview",
                  label: "Invester Firm Name and Photo",
                  Statekey: "investerfirmphoto",
                },

                // {
                //   type: "viewtext",
                //   label: "Invester Name",
                //   Statekey: "investorName",
                //   required: true,
                // },
                {
                  type: "viewtext",
                  label: "Invester Email",
                  Statekey: "investorEmail",
                  required: false,
                },
                // {
                //   type: "viewtext",
                //   label: "Company Name",
                //   Statekey: "companyName",
                //   required: true,
                // },
                {
                  type: "viewtext",
                  label: "Founder Name",
                  Statekey: "founderName",
                  required: false,
                },
                {
                  type: "viewtext",
                  label: "Founder Email",
                  Statekey: "founderEmail",
                  required: false,
                },
              ],
            }[type] || [
              {
                required: true,
                type: "singleselectwithsearch",
                label: "Firm",
                add: {
                  status: true,
                  txt: "Add firm",
                  onadd: () => {
                    navigate(`../admin/firms`);
                  },
                },
                Statekey: "firmId",
                options:
                  firms?.data?.map(({ _id, firmName, logo }) => ({
                    id: _id,
                    name: firmName,
                    show: (
                      <div className="display_group">
                        <div
                          className="photo"
                          style={{
                            backgroundImage: `url("${logo || ""}")`,
                          }}
                        ></div>
                        <div className="txt">{firmName || ""}</div>
                      </div>
                    ),
                  })) || [],
                option_show: (id) => (
                  <div className="display_group">
                    <div
                      className="photo"
                      style={{
                        backgroundImage: `url("${
                          firm_wrt_id?.[id]?.logo || ""
                        }")`,
                      }}
                    ></div>
                    <div className="txt">
                      {firm_wrt_id?.[id]?.firmName || ""}
                    </div>
                  </div>
                ),
              },
              {
                type: "singleselectchips",
                label: "Type",
                Statekey: "type",
                options: filterOpts.Type,
              },
              {
                type: "singleselectchips",
                label: "Sub-Category",
                Statekey: "subCategory",
                options: [
                  { id: "Advisors", name: "Advisors" },
                  { id: "Legal", name: "Legal" },
                  { id: "Others", name: "Others" },
                ],
              },
              {
                required: true,
                type: "multiselect",
                label: "Stage",
                Statekey: "stage",
                options: filterOpts["Funding Round"],
              },
              {
                type: "multiselectwithsearch",
                label: "Sector",
                Statekey: "sector",
                options: filterOpts.Sector,
              },
              {
                type: "text",
                label: "Name",
                Statekey: "name",
                required: true,
              },
              {
                required: true,
                type: "text",
                label: "Email",
                Statekey: "email",
                required: true,
              },
              {
                type: "image",
                label: "Photo",
                Statekey: "photo",
              },
              {
                type: "multiselectwithsearch",
                label: "Cities",
                Statekey: "cities",
                options: filterOpts.City,
              },
              {
                type: "multiselectwithsearch",
                label: "Countries",
                Statekey: "countries",
                options: filterOpts.Country,
              },
              {
                type: "text",
                label: "Designation",
                Statekey: "designation",
              },
              {
                type: "singleselectwithsearch",
                label: "Level",
                Statekey: "level",
                options: [
                  { id: "L1", name: "L1" },
                  { id: "L2", name: "L2" },
                  { id: "L3", name: "L3" },
                ],
              },
              {
                type: "text",
                label: "LinkedIn",
                Statekey: "linkedIn",
              },
              {
                type: "addchipswithinput",
                label: "Past Investments",
                Statekey: "pastInvestments",
                options: [],
                // firms?.data?.map(({ _id, firmName }) => firmName) || [],
              },
              {
                type: "text",
                label: "Remark",
                Statekey: "remarks",
                // required: true,
              },
              {
                type: "singleselectchips",
                label: "Status",
                Statekey: "status",
                options: [
                  { id: "active", name: "Active" },
                  { id: "inactive", name: "Inactive" },
                  { id: "follower", name: "Follower" },
                ],
              },
            ],
            setdata:
              {
                firms: setFirmData,
                users: setuserData,
                admins: setuserData,
                managers: setuserData,
                founders: setuserData,
                companies: setcompanyData,
                introductions: setintroductionData,
              }[type] || setInvestorsData,
            data:
              {
                firms: firmData,
                users: userData,
                admins: userData,
                managers: userData,
                founders: userData,
                companies: companyData,
                introductions: introductionData,
              }[type] || investorsData,
            is_saving: modal.is_saving,
            actions: {
              introductions:
                introductions?.wrt[introductionData?._id]?.mark &&
                introductions?.wrt[introductionData?._id]?.email
                  ? [
                      { type: "markedandemailed", btntype: "done" },
                      { type: "close", btntype: "" },
                    ]
                  : introductions?.wrt[introductionData?._id]?.mark
                  ? [
                      { type: "email", btntype: "dark" },
                      { type: "marked", btntype: "done" },
                      { type: "close", btntype: "" },
                    ]
                  : [
                      { type: "markandemail", btntype: "dark" },
                      { type: "mark", btntype: "dark" },
                      { type: "close", btntype: "" },
                    ],
            }[type] || [
              { type: "save", btntype: "dark" },
              { type: "close", btntype: "" },
            ],
            save: () => {
              const closing = () => {
                setmodal({
                  type: "",
                  is_saving: false,
                });
                setInvestorsData(initialInvestorData);
                setFirmData(initialFirmData);
                setuserData(initialuserData);
                setcompanyData(initialCompaniesData);
              };
              if (type == "firms") {
                ImageToLink(
                  firmData?.logo?.base64 || "",
                  ({ status, response }) => {
                    let formatted_data = {
                      ...firmData,
                      type: "Firm",
                      logo: response?.url || "",
                    };
                    setmodal((prev) => ({ ...prev, is_saving: true }));
                    let config = {
                      method: modal.type == "edit" ? "put" : "post",
                      maxBodyLength: Infinity,
                      url:
                        "/api/investment-firms" +
                        (modal.type == "edit" ? "/" + firmData._id : ""),
                      headers: {
                        "Content-Type": "application/json",
                      },
                      data: formatted_data,
                    };

                    axios
                      .request(config)
                      .then((response) => {
                        if (response.data.error) {
                          return;
                        }
                        closing();
                        dispatch(getInvestorsWithFirms());
                        // dispatch(getInvestors());
                        if (goToMainMerge) {
                          navigate("../mail-merge");
                        }
                        dispatch(getFirms());
                      })
                      .catch((error) => {});
                  }
                );

                return;
              }
              if (["users", "admins", "managers", "founders"].includes(type)) {
                // ImageToLink(
                //   userData?.photo?.base64 || "",
                //   ({ status, response }) => {
                //     let formatted_data = {
                //       ...userData,
                //       photo: response?.url || "",
                //     };

                //     setmodal((prev) => ({ ...prev, is_saving: true }));
                //     let config = {
                //       method: modal.type == "edit" ? "put" : "post",
                //       maxBodyLength: Infinity,
                //       url:
                //         "/api/users" +
                //         (modal.type == "edit" ? "/" + userData._id : ""),
                //       headers: {
                //         "Content-Type": "application/json",
                //       },
                //       data: formatted_data,
                //     };

                //     axios
                //       .request(config)
                //       .then((response) => {
                //         if (response.data.error) {
                //           return;
                //         }
                //         closing();
                //         dispatch(getUsers());
                //       })
                //       .catch((error) => {});
                //   }
                // );
                // ImageToLink(
                //   userData?.photo?.base64 || "",
                //   ({ status, response }) => {
                let formatted_data = {
                  ...userData,

                  // photo: response?.url || "",
                };
                // let formatted_data = {
                //   Admin: {
                //     name: userData?.name,
                //     email: userData?.email,
                //     type: userData?.type,
                //   },
                //   Manager: {
                //     name: userData?.name,
                //     email: userData?.email,
                //     type: userData?.type,
                //     managingCompany: userData?.managingCompany,
                //   },
                //   Founder: {
                //     name: userData?.name,
                //     email: userData?.email,
                //     type: userData?.type,
                //     designation: userData?.designation,
                //     companyId: userData?.companyId,
                //     linkedIn: userData?.linkedIn,
                //   },
                // }[userData.type];

                setmodal((prev) => ({ ...prev, is_saving: true }));
                let config = {
                  method: modal.type == "edit" ? "put" : "post",
                  maxBodyLength: Infinity,
                  url:
                    "/api/users" +
                    (modal.type == "edit" ? "/" + userData._id : ""),
                  headers: {
                    "Content-Type": "application/json",
                  },
                  data: formatted_data,
                };

                axios
                  .request(config)
                  .then((response) => {
                    if (response.data.error) {
                      return;
                    }
                    closing();
                    dispatch(getUsers());
                  })
                  .catch((error) => {});
                // }
                // );
                return;
              }
              if (type == "companies") {
                let formatted_data = {
                  ...companyData,
                  companyName: companyData.name,
                  // companyName: users?.data.filter(
                  //   (user) => user?._id == companyData?.investmentManagerId
                  // )[0]?.name,
                };

                setmodal((prev) => ({ ...prev, is_saving: true }));
                let config = {
                  method: modal.type == "edit" ? "put" : "post",
                  maxBodyLength: Infinity,
                  url:
                    "/api/companies" +
                    (modal.type == "edit" ? "/" + companyData._id : ""),
                  headers: {
                    "Content-Type": "application/json",
                  },
                  data: formatted_data,
                };

                axios
                  .request(config)
                  .then((response) => {
                    if (response.data.error) {
                      return;
                    }
                    closing();
                    dispatch(getCompanies());
                  })
                  .catch((error) => {});
                return;
              }
              ImageToLink(
                investorsData?.photo?.base64 || "",
                ({ status, response }) => {
                  // console.log(response.url);
                  // "https://upload.wikimedia.org/wikipedia/commons/7/7c/Profile_avatar_placeholder_large.png",
                  let formatted_data = {
                    ...investorsData,
                    photo: response.url || "",

                    locationCities: investorsData.cities,
                    locationCountries: investorsData.countries,
                  };
                  console.log(formatted_data);
                  // return;

                  setmodal((prev) => ({ ...prev, is_saving: true }));
                  let config = {
                    method: modal.type == "edit" ? "put" : "post",
                    maxBodyLength: Infinity,
                    url:
                      "/api/investors" +
                      (modal.type == "edit" ? "/" + investorsData._id : ""),
                    headers: {
                      "Content-Type": "application/json",
                    },
                    data: formatted_data,
                  };

                  axios
                    .request(config)
                    .then((response) => {
                      if (response.data.error) {
                        return;
                      }
                      closing();
                      dispatch(getInvestorsWithFirms());
                      dispatch(getInvestors());
                      dispatch(getInvestorsMxailMerge());
                      if (goToMainMerge) {
                        navigate("../type/mail-merge");
                      }
                      // dispatch(getFirms());
                    })
                    .catch((error) => {});
                }
              );
            },
            close: () => {
              setmodal({
                type: "",
                is_saving: false,
              });
              setInvestorsData(initialInvestorData);
              setFirmData(initialFirmData);
              setuserData({
                ...initialuserData,
                type:
                  (type.endsWith("s") ? type.slice(0, -1) : type)
                    .charAt(0)
                    .toUpperCase() +
                    (type.endsWith("s") ? type.slice(0, -1) : type).slice(1) ||
                  "",
              });
              setcompanyData(initialCompaniesData);
            },
            mark: () => {
              dispatch(markIntroduction(introductionData));
              setmodal({
                type: "",
                is_saving: false,
              });
            },
            markandemail: () => {
              // dispatch(markIntroduction(introductionData));
              // dispatch(emailIntroduction(introductionData));
              dispatch(markAndEmailIntroduction(introductionData));
              setmodal({
                type: "",
                is_saving: false,
              });
            },
            deleteentry: () => {},
          }}
        />
      ) : (
        ""
      )}
    </>
  );
};

export default Admin;
